import { useEffect } from "react";

const SITE = "Employee 2 Employer";
const BASE_URL = "https://the-shift-1.preview.emergentagent.com";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Per-page SEO: title, description, canonical, Open Graph, Twitter card, JSON-LD.
 */
export function Seo({ title, description, path = "/", image, type = "website", schema }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${SITE}` : `${SITE} — The Shift by Don Orr Jr.`;
    const url = `${BASE_URL}${path}`;
    const img = image || `${BASE_URL}/og-image.png`;
    document.title = fullTitle;

    upsertMeta("name", "description", description || "");
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description || "");
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", img);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description || "");
    upsertMeta("name", "twitter:image", img);
    upsertLink("canonical", url);

    let ld = document.getElementById("ld-json");
    if (schema) {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "ld-json";
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(schema);
    } else if (ld) {
      ld.remove();
    }
  }, [title, description, path, image, type, schema]);

  return null;
}

export default Seo;
